/**
 * The starter CSV, and the shape it teaches.
 *
 * A file picker with no example is a guess about column order, headers and
 * whether the first row counts. Handing over a two-row file answers all three
 * in the format the parser already expects — `parseCsvTickers` drops the first
 * line, so the header is load-bearing, not decoration.
 *
 * Generated in the browser rather than shipped as an asset: it is three lines,
 * and a static file is one more thing that can drift from the parser.
 */
export const CSV_TEMPLATE = ["Ticker", "AAPL", "MSFT"].join("\n");

export const CSV_TEMPLATE_FILENAME = "newsquawk-portfolio-template.csv";

/** Triggers the download. No-op outside a browser. */
export function downloadPortfolioTemplate(): void {
  if (typeof document === "undefined") return;
  const blob = new Blob([CSV_TEMPLATE], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = CSV_TEMPLATE_FILENAME;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Freed on the next tick — revoking synchronously can cancel the download
  // in some browsers before it has started.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
